const LOCK_CLASS = "body--lock";
const HTML_LOCK_CLASS = "html--lock";

function lockStyles(body, scrollY, paddingOffset) {
    body.style.paddingRight = `${paddingOffset}px`;
    body.style.position = "fixed";
    body.style.top = `-${scrollY}px`;
    body.style.left = "0";
    body.style.right = "0";
    body.style.width = "100%";
}

function clearLockStyles(body) {
    body.style.paddingRight = null;
    body.style.position = null;
    body.style.top = null;
    body.style.left = null;
    body.style.right = null;
    body.style.width = null;
}

export const BodyScroll = {
    lock() {
        const body = document.querySelector(".body");
        if (!body) {
            return;
        }

        document.documentElement.classList.add(HTML_LOCK_CLASS);

        if (body.classList.contains(LOCK_CLASS)) {
            return;
        }

        const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
        const paddingOffset = window.innerWidth - body.offsetWidth;
        body.dataset.scrollLockY = String(scrollY);
        body.classList.add(LOCK_CLASS);
        lockStyles(body, scrollY, paddingOffset);
    },

    unlock() {
        const body = document.querySelector(".body");
        if (!body) {
            return;
        }

        document.documentElement.classList.remove(HTML_LOCK_CLASS);

        if (!body.classList.contains(LOCK_CLASS)) {
            return;
        }

        const scrollY = Number(body.dataset.scrollLockY || 0);
        body.classList.remove(LOCK_CLASS);
        delete body.dataset.scrollLockY;
        clearLockStyles(body);
        const html = document.documentElement;
        html.style.scrollBehavior = "auto";
        window.scrollTo(0, scrollY);
        html.scrollTop = scrollY;
        html.style.removeProperty("scroll-behavior");
    },
};
